const TOKEN_KEY = "eltt_admin_token";

function notifyAuthChanged() {
  window.dispatchEvent(new Event("eltt:auth-changed"));
}

export function getToken() {
  return window.localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  window.localStorage.setItem(TOKEN_KEY, token);
  notifyAuthChanged();
}

export function clearToken() {
  window.localStorage.removeItem(TOKEN_KEY);
  notifyAuthChanged();
}
